/* One element per current cart render. No inline executable scripts in fetched HTML. */
(() => {
  if (customElements.get('pogo-cart-recommendations')) return;
  customElements.define('pogo-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-currency', 'data-locale'] });
      this.refresh();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.request?.abort();
      this.signature = null;
    }
    async refresh() {
      const data = this.querySelector('[data-pogo-cart-products]');
      const output = this.querySelector('[data-pogo-cart-output]');
      if (!data || !output) return;
      let ids;
      try { ids = [...new Set(JSON.parse(data.textContent).map(String))]; } catch { return; }
      // Include the output node: Horizon may replace it while preserving this custom element.
      const signature = JSON.stringify([ids, this.dataset.currency, this.dataset.locale]);
      if (signature === this.signature && output === this.output &&
          !(this.rendered && !output.querySelector('.pogo-cart-recommendations__grid'))) return;
      this.rendered = false;
      this.signature = signature;
      this.output = output;
      this.request?.abort();
      this.request = new AbortController();
      const { signal } = this.request;
      this.hidden = true;
      output.replaceChildren();
      if (!ids.length) return;
      try {
        const root = (this.dataset.root || '/').replace(/\/?$/, '/');
        const results = await Promise.all(ids.map(async (id) => {
          try {
            const url = new URL(`${root}recommendations/products.json`, location.origin);
            url.search = new URLSearchParams({ product_id: id, limit: '10', intent: 'complementary' });
            const response = await fetch(url, { signal });
            if (!response.ok) return [];
            const body = await response.json();
            return Array.isArray(body.products) ? body.products : [];
          } catch (error) { if (error.name === 'AbortError') throw error; return []; }
        }));
        if (signal.aborted || !this.isConnected) return;
        const seen = new Set(ids);
        const products = [];
        for (const product of results.flat()) {
          if (seen.has(String(product.id)) || !product.featured_image) continue;
          seen.add(String(product.id)); products.push(product);
          if (products.length === 4) break;
        }
        if (!products.length) return;
        const formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', {
          style: 'currency', currency: this.dataset.currency || 'USD'
        });
        const heading = document.createElement('h3');
        heading.className = 'pogo-cart-recommendations__heading';
        heading.textContent = this.dataset.heading || 'Complimentary pieces';
        const grid = document.createElement('div');
        grid.className = 'pogo-cart-recommendations__grid';
        for (const product of products) {
          const href = new URL(product.url, location.origin);
          if (href.origin !== location.origin) continue;
          const imageUrl = new URL(product.featured_image, location.origin);
          if (!['http:', 'https:'].includes(imageUrl.protocol)) continue;
          imageUrl.searchParams.set('width', '400');
          const link = document.createElement('a');
          link.className = 'pogo-cart-recommendations__item'; link.href = href.href;
          const image = document.createElement('img');
          image.className = 'pogo-cart-recommendations__image'; image.src = imageUrl.href;
          image.alt = product.title || ''; image.width = 400; image.height = 400; image.loading = 'lazy';
          const title = document.createElement('span');
          title.className = 'pogo-cart-recommendations__title'; title.textContent = product.title;
          const price = document.createElement('span');
          price.className = 'pogo-cart-recommendations__price'; price.textContent = formatter.format(Number(product.price) / 100);
          link.append(image, title, price); grid.append(link);
        }
        if (!grid.children.length) return;
        output.replaceChildren(heading, grid); this.rendered = true; this.hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('POGO recommendations unavailable', error);
      }
    }
  });
})();
